import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { AppState } from 'src/store/Store';
import { TournamentsTypes } from 'src/services/tournaments/addTournament';

const useValidationSchema = () => {
  const { t } = useTranslation();

  const selectedTournament = useSelector(
    (state: AppState) => state.tournamentReducer.selectedTournament,
  );

  const isSingleElimination =
    selectedTournament?.tournament_type?.id === TournamentsTypes.SINGLE_ELIMINATION;

  const schema = Yup.object().shape({
    players: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required(t('TournamentTeams.playerNameRequired')),
        phone: Yup.string().required(t('TournamentTeams.playerPhoneRequired')),
      }),
    ),
    versus_team: isSingleElimination
      ? Yup.string().required(t('TournamentTeams.versusTeamRequired'))
      : Yup.string().notRequired(),
  });

  return { validationSchema: schema };
};

export default useValidationSchema;
